import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {formatDate} from "../../../shared/services/utils/utils";
import './TaskResponseRow.scss';
import LoadingButton from "../../../shared/ui/LoadingButton";
import {connect} from "react-redux";
import taskTrainingActionCreators from "../../store/task-training/action-creators";

class TaskResponseRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rejectCommentMap: {},
      ackCommentMap: {},
      openedRejectCommentMap: {},
      openedAckCommentMap: {}
    }
  }

  setRejectComment(tr, e) {
    this.setState({
      rejectCommentMap: {
        ...this.state.rejectCommentMap,
        [tr.guid]: e.target.value
      }
    })
  }

  setAckComment(tr, e) {
    this.setState({
      ackCommentMap: {
        ...this.state.ackCommentMap,
        [tr.guid]: e.target.value
      }
    })
  }

  rejectTaskResponse(tr) {
    if (this.state.rejectCommentMap[tr.guid]) {
      this.props.onRejectResponse({
        taskResponseGuid: tr.guid,
        taskGuid: tr.task.guid,
        oitGuid: tr.oit.guid,
        rejectedAt: new Date(),
        isFormSubmitted: false,
        comment: this.state.rejectCommentMap[tr.guid]
      })
    }

    this.closeRejectComment(tr);
  }

  ackTaskResponse(tr) {
    /**if(!this.state.ackCommentMap[tr.guid]) {
      this.setState({
        isFormSubmitted: true
      })
      return
    }*/
    this.props.akcResponse(tr.guid,  this.state.ackCommentMap[tr.guid], this.props.userContext.userGuid)
      .then(() => {
        this.closeAckComment(tr)
      })
  }

  openRejectComment(tr) {
    this.setState({
      openedRejectCommentMap: {
        ...this.state.openedRejectCommentMap,
        [tr.guid]: true
      }
    })
  }
  openAckComment(tr) {
    this.setState({
      openedAckCommentMap: {
        ...this.state.openedAckCommentMap,
        [tr.guid]: true
      }
    })
  }

  closeRejectComment(tr) {
    this.setState({
      openedRejectCommentMap: {
        ...this.state.openedRejectCommentMap,
        [tr.guid]: false
      }
    })
  }

  closeAckComment(tr) {
    this.setState({
      openedAckCommentMap: {
        ...this.state.openedAckCommentMap,
        [tr.guid]: false
      }
    })
  }

  render() {
    return (
      <div>
        {this.props.task.taskResponses.map(tr => tr.guid !== (this.props.editingResponse && this.props.editingResponse.guid)
          ? (
            <Fragment key={tr.guid}>
              <div className="task-training-responses">
                <div className="task-response-action">{tr.action}</div>
                <div className="task-response-submitted-by">
                  <i className="fa fa-user-secret"/> <b>{this.props.ftoShortLabel} - {tr.author.name}</b>
                </div>
                <div className="task-response-action-at"><i className="fa fa-calendar"/> {formatDate(tr.actionAt)}
                </div>
                {!tr.acknowledgedAt && tr.status === 'submitted' && (!this.props.taskGroup.flow || this.props.taskGroup.flow.acknowledger) && (
                  <span className="badge badge-danger">Waiting acknowledgement</span>
                )}

                {this.props.canAddOrEdit && tr.status !== 'rejected' &&
                <button style={{marginLeft: '10px'}} className="button secondary small"
                        onClick={() => this.props.onEditResponse(tr)}>
                  <i className="fa fa-edit"/>
                  <span>Edit</span>
                </button>}

                {tr.status === 'draft' && (
                  <div style={{marginLeft: '10px'}}>
                    <LoadingButton
                      primary
                      small
                      icon="fa fa-check"
                      text="Submit"
                      isLoading={this.props.isLoading}
                      onClick={() => this.props.onSubmitResponse(tr)}/>
                  </div>
                )}
                {!this.state.openedRejectCommentMap[tr.guid] && this.props.canAddOrEdit && tr.status !== 'rejected' &&
                <div style={{marginLeft: '10px'}}>
                  <LoadingButton
                    danger
                    small
                    icon="fa fa-close"
                    text="Reject"
                    isLoading={this.props.isLoading}
                    onClick={() => this.openRejectComment(tr)}/>
                </div>
                }
                {!this.state.openedAckCommentMap[tr.guid] && !this.props.canAddOrEdit && tr.status === 'submitted' &&
                <div style={{marginLeft: '10px'}}>
                  <LoadingButton
                    secondary
                    small
                    icon="fa fa-thumbs-up"
                    text="Acknowledge"
                    isLoading={this.props.isLoading}
                    onClick={() => this.openAckComment(tr)}/>
                </div>
                }
              </div>
              {this.state.openedRejectCommentMap[tr.guid] && (
                <Fragment>
                  <br/>
                  <textarea
                    placeholder="Add reject comment"
                    className="form-control"
                    onChange={(e) => this.setRejectComment(tr, e)}
                    value={this.state.rejectCommentMap[tr.guid]}>
                  </textarea>
                  <br/>
                  <div>
                    <LoadingButton
                      primary
                      small
                      icon="fa fa-check"
                      text="Reject"
                      isLoading={this.props.isLoading}
                      onClick={() => this.rejectTaskResponse(tr)}/>
                    <span> </span>
                    <LoadingButton
                      danger
                      small
                      icon="fa fa-close"
                      text="Cancel"
                      isLoading={false}
                      onClick={() => this.closeRejectComment(tr)}/>
                  </div>
                </Fragment>
              )}
              {this.state.openedAckCommentMap[tr.guid] && (
                <Fragment>
                  <br/>
                  <textarea
                    placeholder="Add acknowledgement comment"
                    className="form-control"
                    onChange={(e) => this.setAckComment(tr, e)}
                    value={this.state.ackCommentMap[tr.guid]}>
                  </textarea>
                  {this.state.isFormSubmitted && <div style={{fontSize: '0.9em', color: '#bf292a'}}>
                    You must fill the acknowledgement comments before you can submit
                  </div>}
                  <br/>
                  {this.props.userContext && this.props.userContext.hasScope('oit') ?
                    <div style={{fontSize: '0.8em'}}>
                      I acknowledge that I have reviewed and fully understand all of the details of this form and I am
                      comfortable appropriately executing this training experience
                    </div>
                    : <div style={{fontSize: '0.8em'}}>
                      I have reviewed this task and acknowledge its completion by the recruit
                    </div>}
                  <br/>
                  <div>
                    <LoadingButton
                      primary
                      small
                      icon="fa fa-thumbs-up"
                      text="Acknowledge"
                      isLoading={this.props.isLoading}
                      onClick={() => this.ackTaskResponse(tr)}/>
                    <span> </span>
                    <LoadingButton
                      danger
                      small
                      icon="fa fa-close"
                      text="Cancel"
                      isLoading={false}
                      onClick={() => this.closeAckComment(tr)}/>
                  </div>
                </Fragment>
              )}
              {tr.status === 'rejected' && (
                <div className="task-response-comment negative">
                  <div><b>REJECTED by {tr.rejectedBy}</b></div>
                  <div style={{fontSize: '0.9em'}}>{tr.rejectComment}</div>
                </div>
              )}
              {tr.authorComment && (
                <div className="task-response-comment">
                  <div><b>{tr.author.name}'s Comment</b></div>
                  <div style={{fontSize: '0.9em'}}>{tr.authorComment}</div>
                </div>
              )}
              {tr.substandard && (
                <div className="substandard-response"><i className="fa fa-warning"/> This task was performed below
                  standards.</div>
              )}
              {tr.acknowledgedAt && (
                <div className="task-training-responses acknowledged" key={tr.guid}>
                  <div className="task-response-action">Acknowledged</div>
                  <div className="task-response-submitted-by">
                    <i className="fa fa-user-secret"/> <b>{this.props.oitShortLabel} - {tr.oit.name}</b>
                  </div>
                  <div className="task-response-action-at"><i
                    className="fa fa-calendar"/> {formatDate(tr.acknowledgedAt)}</div>
                </div>
              )}
              {tr.oitComment && (
                <div className="task-response-comment">
                  <div><b>{tr.oit.name}'s Comment</b></div>
                  <div style={{fontSize: '0.9em'}}>{tr.oitComment}</div>
                </div>
              )}
            </Fragment>
          )
          : null)
        }
      </div>
    );
  }
}

TaskResponseRow.propTypes = {
  task: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    akcResponse: (taskResponseGuid, comment, oitGuid) => {
      return dispatch(taskTrainingActionCreators.ackResponse(taskResponseGuid, comment, oitGuid))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskResponseRow);
